export const HOW_IT_WORKS_CLOSED_STORAGE_KEY = 'cr158HowItWorksClosed';

export const HOW_IT_WORKS_STEPS = [
  {
    title: 'Find a Restaurant',
    description: 'Browse restaurants near you and discover new cuisines.',
  },
  {
    title: 'Book the First Table',
    description:
      'Pay a small booking fee to secure your table. Your reservation is confirmed instantly.',
  },
  {
    title: 'Enjoy 50% Off',
    description:
      'Save on your meal while receiving the same great food and service as full-paying customers.',
  },
] as const;
